module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "acknowledgments-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Acknowledgments")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "acknowledgments-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("I give thanks always to my Heavenly Father, who provides the creativity that allows me to write these stories. I’m also grateful for my family and the leeway they give me to disappear for hours at a time while I write.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Thanks to Naleighna Kai for conceptualizing and including me in the world of the Kings and Knights of the Castle. Your editing pen keeps me on the straight and narrow.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("No book is complete without beta readers and with that said, I’m grateful to Debra Mitchell for her insightful comments and ideas. I’m grateful also to April Bubb and Kelsie Maxwell for their keen eyes and helpful suggestions.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It has been a pleasure working with this group of writers to bring the Knights of the Castle to the world. Karen D. Bradley was gracious enough to let me use her characters and their gizmos.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("J. L. Woodson, keep on shining through the excellent work you do with these covers. One day, I will say, “I knew him when …”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Kings of the Castle Ambassadors, NK Tribe Called Succes, and readers in the Naleighna Kai Literary Café are a constant source of encouragement and support. Special mention goes to Brenda Powell Pious, Joyce M. Hudson, Kelsie Maxwell, and Carol Jones, who allowed me to name characters for them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Thank you.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f08f2672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgments.vue
// module id = 69
// module chunks = 0